/**
 * Límite por imagen de producto / catálogo (cliente).
 * En s3-database el tamaño efectivo tras conversión WebP se valida con env MAX_SIZE_KB
 * (ver `s3-database/utils/env/env.go`): en producción debe estar alineado con este límite.
 */
export const PRODUCT_IMAGE_MAX_MB = 5;
export const PRODUCT_IMAGE_MAX_BYTES = PRODUCT_IMAGE_MAX_MB * 1024 * 1024;

/** Mensaje de error al rechazar subida en cliente (uploadFile / catch). */
export const CLIENT_IMAGE_TOO_LARGE_MESSAGE = "client_image_too_large";
